import React from "react";

export class CookiePolicyNL extends React.Component {
    render() {
        return (
            <>
                <p>
                    Laatste update: <b>28/11/2024</b>
                    <br />
                    <br />
                </p>
                <p>
                    Dit document is opgesteld in overeenstemming met EU-verordening 2016/679 (de "GDPR") om gebruikers in staat te stellen te begrijpen welke cookies worden
                    geïnstalleerd, wanneer zij een DeepUnity PACSonWEB-portaal (de "Website") gebruiken.
                </p>
                <h2>1. Gegevensbeheerder en functionaris voor gegevensbescherming</h2>
                <p>
                    DH Healthcare GmbH, met maatschappelijke zetel te Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, is de verantwoordelijke voor de verwerking van de persoonsgegevens
                    (de Gegevens) van de gebruikers van de Website die verzameld worden met behulp van cookies. Voor elk verzoek is het mogelijk DH Healthcare GmbH aan te schrijven
                    op bovenvermeld fysiek adres of via het e-mailadres.
                    <br />
                    <br />
                    DH Healthcare GmbH heeft een functionaris voor gegevensbescherming ("DPO") aangesteld, die bereikbaar is op dpo.belgium@dedalus.eu.
                </p>
                <h2>2. Door DH Healthcare GmbH verwerkte gegevens</h2>
                <p>
                    De navigatie op de Website gaat gepaard met het gebruik van cookies, korte tekstreeksen die de bezochte websites naar de browser van de gebruiker sturen, waar
                    ze worden opgeslagen en vervolgens bij volgende bezoeken aan dezelfde websites worden doorgegeven. Tijdens het surfen op een site kan de gebruiker ook cookies
                    op zijn computer ontvangen van andere sites of webservers dan degene die hij/zij bezoekt (zogenaamde "third party" cookies). Er kan onderscheid worden gemaakt
                    tussen
                    <br />
                    <br />
                    a. Technische cookies, die het mogelijk maken activiteiten uit te voeren die verband houden met de werking van de Site.
                    <br />
                    <br />
                    b. Profileringscookies, die worden gebruikt om het gedrag van de gebruiker te analyseren en, indien nodig, om reclameboodschappen te sturen in overeenstemming
                    met de voorkeuren die de gebruiker tijdens de navigatie heeft aangegeven.
                    <br />
                    <br />
                    c. Lokale opslag, waarmee activiteiten kunnen worden uitgevoerd die verband houden met de werking van de Site.
                </p>
                <p>
                    <br />
                    Deze Website gebruikt de volgende cookies:
                </p>
                <h3>a) Technische cookies</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Host</th>
                            <th>Categorie</th>
                            <th>Beschrijving</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.ASPXAUTH</td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>DeepUnity PACSonWEB portaalverificatie</td>
                        </tr>
                        <tr>
                            <td>ASP.NET_SessionId</td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>DeepUnity PACSonWEB portaalsessie-ID</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>Deze cookie wordt ingesteld als u ervoor kiest om alle cookies toe te staan en registreert wanneer hij is ingesteld.</td>
                        </tr>
                        <tr>
                            <td>.AspNetCore.Culture </td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>Registreert de taalkeuze zodra deze handmatig wordt gewijzigd.</td>
                        </tr>
                        <tr>
                            <td>POWLanguage</td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>Registreert de taalkeuze zodra deze handmatig wordt gewijzigd (De browsertaal wordt als standaard gebruikt).</td>
                        </tr>
                        <tr>
                            <td>RETURNSCU</td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>Klantportaal waarop u bent ingelogd.</td>
                        </tr>
                        <tr>
                            <td>Dobco.LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>Registreert de lokale image caches, gekoppeld aan de gebruiker.</td>
                        </tr>
                        <tr>
                            <td>Dobco.ExternalLogin</td>
                            <td>Dobco</td>
                            <td>Noodzakelijk</td>
                            <td>Dit wordt gebruikt om de status op te slaan tijdens een externe aanmeldingsronde. Dit is nodig om veiligheidsredenen om CSRF en replay-aanvallen te voorkomen. De cookie wordt versleuteld.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Functioneel</td>
                            <td>Deze cookie wordt ingesteld als u ervoor kiest om alle cookies toe te staan en registreert wanneer hij is ingesteld.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Cookies voor analyse/profilering</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Host</th>
                            <th>Duur</th>
                            <th>Categorie</th>
                            <th>Beschrijving</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 jaar</td>
                            <td>Analyse</td>
                            <td>Wordt gebruikt om gebruikers te onderscheiden.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 uur</td>
                            <td>Analyse</td>
                            <td>Wordt gebruikt om gebruikers te onderscheiden.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 jaar</td>
                            <td>Analyse</td>
                            <td>Wordt gebruikt om de sessiestatus te behouden.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Lokale opslag (Host: Dobco; Categorie : Noodzakelijk)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Beschrijving</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-shownNews</td>
                            <td> De laatste keer dat u de berichten hebt geopend.</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td> ID voor het gebruik van HomeReading.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3StudyTutorial</td>
                            <td> Registreert of de handleiding al is getoond.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td> Voorkeursinstellingen voor het delen van een onderzoek.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td> Voorkeursinstelling voor het afdrukken van een onderzoek.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginSource</td>
                            <td> Klantportaal waarop u bent ingelogd.</td>
                        </tr>
                        <tr>
                            <td>cookie-acceptedPOW3Cookies</td>
                            <td> Registreert of het cookiebeleid al is weergegeven.</td>
                        </tr>
                        <tr>
                            <td>ShownImportNews</td>
                            <td> Opname van de al getoonde belangrijke nieuwsfeiten.</td>
                        </tr>
                        <tr>
                            <td>Reportfontsize</td>
                            <td> Lettergrootte van het rapport in de viewer.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginOption</td>
                            <td> Hoe je bent ingelogd (patiënt/arts).</td>
                        </tr>
                        <tr>
                            <td>cookie-uniqueBrowserIdentifier</td>
                            <td>
                                Identificeert op unieke wijze uw browser binnen DeepUnity PACSonWEB. Het wordt gebruikt om te bepalen of u gevraagd wordt om een OTP in te voeren
                                tijdens het inloggen of niet.
                            </td>
                        </tr>
                        <tr>
                            <td>cookie-last-audio-out-volume</td>
                            <td> Slaat het laatst gebruikte volumeniveau op.</td>
                        </tr>
                        <tr>
                            <td>cookie-PreferredRecognitionLanguage</td>
                            <td>Slaat je voorkeurstaal voor spraakherkenning op.</td>
                        </tr>
                        <tr>
                            <td>cookie-scalingFactorConfiguration</td>
                            <td>Slaat uw gewenste schaalfactor en de bijbehorende startresolutie op.</td>
                        </tr>
                        <tr>
                            <td>cookie-dontShowPopupForNewsIds</td>
                            <td>Geeft aan welke pop-ups van nieuwsberichten u niet meer wilt zien.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Noodzakelijke technische cookies kunnen niet door de gebruiker van de Website worden geweigerd, aangezien zij strikt noodzakelijk zijn voor de Website zelf. De
                    gebruiker kan wel er vrij voor kiezen het gebruik van analytische, profilerende en niet strikt noodzakelijke cookies te aanvaarden of te weigeren. De gebruiker
                    kan zijn keuzes met betrekking tot cookies instellen en herzien met de functie "Cookie instellingen aanpassen" die beschikbaar is op de website (Sectie
                    ‘Legal’).
                </p>
                <h2>3. Doeleinden en rechtsgrondslag van de verwerking</h2>
                <p>
                    Door het gebruik van cookies worden de volgende doeleinden nagestreefd:
                    <br />
                    <br />
                    3.1. Om de navigatie van de Website en de vlotte functionaliteit ervan mogelijk te maken. De rechtsgrondslag voor de verwerking is het verlenen van diensten aan
                    gebruikers met betrekking tot de Website en het gerechtvaardigd belang van Dedalus om een functionele website te hebben.
                    <br />
                    3.2. Om te voldoen aan verplichtingen uit hoofde van toepasselijke wet- en regelgeving of EU-wetgeving, of om te voldoen aan verzoeken van de autoriteiten. De
                    rechtsgrondslag voor de verwerking is de verplichting van Dedalus om te voldoen aan dwingende wetgeving.
                    <br />
                    3.3. Het gedrag van de gebruiker te analyseren en hem eventueel reclameboodschappen te sturen in overeenstemming met de voorkeuren die hij tijdens de navigatie
                    heeft aangegeven. De rechtsgrondslag voor de verwerking is in dit geval de toestemming van de betrokkene.
                    <br />
                    3.4. Voor de behoeften van de verdediging van de rechten van Dedalus in het kader van eventuele geschillen, zelfs voor de rechtbank. De rechtsgrondslag van de
                    verwerking is het legitieme belang van de Eigenaar om zijn rechten te beschermen.
                    <br />
                    <br />
                    Het verstrekken van Gegevens is optioneel, maar (behalve in gevallen van verwerking op basis van toestemming) het niet verstrekken van Gegevens verhindert de
                    Beheerder om de navigatie van de Website toe te staan.
                </p>
                <h2>4. Ontvangers van de gegevens</h2>
                <p>
                    De gegevens kunnen worden meegedeeld
                    <br />
                    <br />
                    (a) aan derden die specifieke activiteiten in verband met de Gegevens moeten verrichten, in overeenstemming met de doeleinden van de verwerking, of aan
                    dienstverleners van de verantwoordelijke voor de verwerking.
                    <br />
                    (b) aan autoriteiten, entiteiten en/of partijen aan wie de Gegevens moeten worden verstrekt, krachtens bindende wettelijke of contractuele bepalingen.
                    <br />
                    (c) in andere omstandigheden, zoals overnames en verkopen aan potentiële derden, wanneer wij verwachten een deel van of al onze activiteiten te verkopen of over
                    te dragen.
                </p>
                <h2>5. Doorgifte van gegevens buiten de Europese Economische Ruimte</h2>
                <p>
                    Wat betreft de mogelijke doorgifte van gegevens naar landen die niet tot de Europese Economische Ruimte behoren, zal de verwerking plaatsvinden volgens een van
                    de wettelijk toegestane methoden en dus door de selectie van ontvangers die gevestigd zijn in landen die door de Europese Commissie als adequaat worden
                    beschouwd of door het bedingen van contractuele standaardclausules.
                </p>
                <h2>6. Bewaring van gegevens</h2>
                <p>
                    De gegevens worden niet langer bewaard dan nodig is voor de doeleinden waarvoor ze zijn verzameld, met inachtneming van de beginselen van beperking van de
                    bewaring en minimalisering. Meer in het bijzonder zijn de termijnen van de duur van de cookies gedefinieerd in de vorige sectie 2. Voor de gegevens waarvan de
                    verwerking is gebaseerd op de toestemming van de betrokkene, wordt gespecificeerd dat deze worden bewaard totdat deze toestemming wordt ingetrokken.
                </p>
                <h2>7. Rechten van de betrokkenen</h2>
                <p>
                    In aanwezigheid van de relevante wettelijke voorwaarden kan de betrokkene de verantwoordelijke voor de verwerking of de DPO verzoeken om toegang tot zijn/haar
                    gegevens, om rectificatie of wissing ervan of om bezwaar tegen de verwerking ervan, om beperking van de verwerking in de gevallen als bedoeld in artikel 18
                    GDPR, alsmede om verkrijging in een gestructureerd, algemeen gebruikt en machineleesbaar formaat van de gegevens die hem/haar betreffen, in de gevallen als
                    bedoeld in artikel 20 GDPR.
                    <br />
                    <br />
                    Bovendien heeft de gebruiker het recht elke toestemming voor verwerking te allen tijde in te trekken, zonder dat dit afbreuk doet aan de rechtmatigheid van de
                    verwerking die de verantwoordelijke voor de intrekking heeft verricht.
                    <br />
                    <br />
                    Verzoeken dienen schriftelijk te worden gericht aan de verantwoordelijke voor de verwerking op de hierboven vermelde adressen.
                    <br />
                    <br />
                    In ieder geval kan de betrokkene een klacht indienen bij de bevoegde toezichthoudende autoriteit voor gegevensbescherming indien deze van mening is dat de
                    verwerking van de gegevens in strijd is met de geldende regelgeving.
                </p>
            </>
        );
    }
}
